module.exports = __webpack_public_path__ + "static/media/plane(28).d036dc5a.PNG";